import { Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { Module, withFeature, withModule, withPermission } from "@skylab-shared/business";
import { FeatureFlags } from "@skylab-shared/config";
import { UserPermissionKind } from "@skylab-shared/dataModel";

@Directive({ selector: '[sklAvailability]' })
export class AvailabilityDirective implements OnInit, OnDestroy {
    @Input() public sklAvailability: (keyof typeof UserPermissionKind)[] = [];
    @Input() public sklAvailabilityFeatures: (keyof FeatureFlags)[] = [];
    @Input() public sklAvailabilityModules: Module[] = [];
    private view!: EmbeddedViewRef<any>;

    public constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) { }

    public ngOnInit(): void {
        const processElement = (isAvailable: boolean) => isAvailable ? this.create() : this.clear();

        const permission = this.sklAvailability.length ? withPermission(this.sklAvailability.map(elem => UserPermissionKind[elem])) : true;
        const features = this.sklAvailabilityFeatures.length ? withFeature(this.sklAvailabilityFeatures) : true;
        const modules = this.sklAvailabilityModules.length ? withModule(this.sklAvailabilityModules) : true;

        processElement(permission && features && modules);
    }

    public ngOnDestroy(): void {
        this.view?.destroy();
    }

    private create(): void {
        this.view = this.viewContainer.createEmbeddedView(this.templateRef);
    }

    private clear(): void {
        this.viewContainer.clear();
    }
}
